import type { Capture } from '@daily/shared';
import { CaptureTile } from './CaptureTile';

interface CapturesGridProps {
  captures: Capture[];
  onSelect?: (capture: Capture) => void;
}

export function CapturesGrid({ captures, onSelect }: CapturesGridProps) {
  if (captures.length === 0) {
    return (
      <div className="rounded-md bg-cardWarm p-10 flex flex-col items-center justify-center text-center gap-2 min-h-[400px]">
        <span className="text-eyebrow uppercase tracking-[0.18em] text-inkFaded">
          The corkboard
        </span>
        <p className="font-serif italic text-display-sm text-inkFaded">
          Nothing on the wall yet.
        </p>
        <p className="text-body-sm text-inkFaded max-w-xs">
          Photograph a letter, an invite, a drawing — Claude reads it and pins
          it here in fifteen seconds.
        </p>
      </div>
    );
  }
  // 1 capture → full hero. 2 → side-by-side. 3+ → 3-col grid (rows of 3).
  // Below md, drop to 2-col so tiles don't crush.
  const cols =
    captures.length === 1
      ? 'grid-cols-1'
      : captures.length === 2
        ? 'grid-cols-2'
        : 'grid-cols-2 md:grid-cols-3';
  return (
    <div className={`grid ${cols} gap-3 sm:gap-4 auto-rows-fr`}>
      {captures.map((c) => (
        <CaptureTile key={c.id} capture={c} onClick={onSelect ? () => onSelect(c) : undefined} />
      ))}
    </div>
  );
}
